import { StyledImageLogo } from '../TheWestHeader.styled'
import { createHeaderLogo, LogoProps } from './createHeaderLogo'

const logoFile = require('./images/masthead-south-western-times.png')

const props: LogoProps = {
    alt: 'South Western Times',
    src: logoFile,
    ampInitialSize: {
        width: 618,
        height: 52,
    },
    verticalSpacing: 14,
}

export default createHeaderLogo(StyledImageLogo, props)
